import {SpeedDial, Tooltip} from '@mui/material'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import {FormattedMessage} from 'react-intl'

export interface LicenseUploadActionButtonProps {
  onClick: () => void
}

const LicenseUploadActionButton = (props: LicenseUploadActionButtonProps) => {
  return (
    <Tooltip
      title={
        <FormattedMessage
          id='LicenseApp.ImportButton.Tooltip'
          defaultMessage='<b>Import License</b><br></br>Import am existing license license file.'
        />
      }
    >
      <SpeedDial
        ariaLabel={'add-menu'}
        icon={<FileUploadOutlinedIcon />}
        sx={{
          position: 'absolute',
          transform: 'translateY(-50%)'
        }}
        onClick={props.onClick}
      ></SpeedDial>
    </Tooltip>
  )
}

export default LicenseUploadActionButton
